'use strict';

define([
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/main',
  'es6!launcher/util/listbuilder/constants',
], function(ListBuilderService, Constants) {
  return function(api) {
    var service;

    var init = function(opts, done) {
      if (api.properties.apps.indexOf(Constants.APP_ID) === -1) return done();

      require(['plugins/css!../css/listbuilder/listbuilder-popup.css'], function() {
        service = new ListBuilderService(api);
      });

      done();
    };

    var destroy = function(done) {
      done();
    };

    return {
      init: init,
      destroy: destroy,
    };
  };

});
